export type ProjetCommon_State = {
  user: string
  projectName: string
  address?: string | null
  addressComponents?: ProjetCommon_Address | null
  avancement: string
  description: string
}

export type ProjetCommon_Address = {
  street_number: string
  postal_code: string
  route: string
  city: string
  country: string
  locality: string
  gps?: { lat: number; lon: number }
}

const ProjetCommonReducer: ProjetCommon_State = {
  user: '',
  projectName: '',
  address: undefined,
  addressComponents: undefined,
  avancement: '0',
  description: ''
}

export default ProjetCommonReducer
